// import escrowSearch from "../../scripts/escrowSearch";
// import escrowModal from '../../scripts/escrowModal'
import animateSwitcher from '../../scripts/animateSwitcher'
import { getQueryParameterByName, scrollToElem } from '../../utils'

export default {
	data() {
		return {
			escrowSlider: null,
			escrowNavTabs: 'about',
			switcherChecker: false,
			escrowCalcInfo: '',
		}
	},
	updated() {
		if (this.escrowNavTabs === 'docs' && this.switcherChecker === false) {
			this.switcherChecker = true
			animateSwitcher()
		} else if (this.escrowNavTabs !== 'docs') {
			this.switcherChecker = false
		}
		// поиска пока нет, это тоже не нужно
		// if (this.escrowNavTabs === 'objects') {
		// 	escrowSearch();
		// }
	},
	mounted() {
		// escrowModal();
		this.checkGetParams();
	},
	methods: {
		checkGetParams() {
			if (getQueryParameterByName('tab') === 'docs') {
				this.escrowNavTabs = 'docs';
			}
		},
		selectEscrowTab(tab) {
			this.escrowNavTabs = tab;
			// window.scrollTo(0, 0);
		},
		setEscrowCalcInfo(info) {
			this.escrowCalcInfo = info;
		},
		escrowGetConsultation() {
			if (this.escrowNavTabs === 'docs') this.escrowNavTabs = 'about';
			scrollToElem('escrowFeedback');
		},
	}
}
